module.exports = __webpack_public_path__ + "static/media/wolf walking.835ff22d.gif";